import { render } from "./SchoolServiceUsages.vue?vue&type=template&id=1bf9e074&scoped=true&ts=true"
import script from "./SchoolServiceUsages.vue?vue&type=script&lang=ts"
export * from "./SchoolServiceUsages.vue?vue&type=script&lang=ts"

import "./SchoolServiceUsages.vue?vue&type=style&index=0&id=1bf9e074&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf9e074"]])

export default __exports__